import $ from 'jquery';
const TITLE = '.js-accord-title';
const BODY = '.js-accord-body';
const ARROW = '.ProductAccordion-arrow';
const toggle = function(title) {
    title.next(BODY).slideToggle();
    title.find(ARROW).toggleClass('open');
    title.toggleClass('is-open');
    // Only sections that opt into the ARIA pattern declare `aria-expanded`
    const expanded = title.attr('aria-expanded');
    if (expanded !== undefined) {
        title.attr('aria-expanded', expanded === 'true' ? 'false' : 'true');
    }
};
export const init = async function() {
    $(document).on('click', TITLE, (event)=>{
        toggle($(event.currentTarget));
    });
    //KEYBOARD USERS
    $(document).on('keyup', TITLE, (event)=>{
        if (event.keyCode !== 13) {
            return;
        }
        const title = $(event.currentTarget);
        // Native buttons already fire a click for Enter/Space, so handling the
        // keyup here as well would toggle the panel twice.
        if (title.is('button')) {
            return;
        }
        toggle(title);
    });
};
